(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Shortcuts;
     
    (function (Shortcuts, $, undefined) {
        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * TODO write object documentation here
         * @memberOf Lfl.Shortcuts
         */
        Lfl.Shortcuts.ShortcutsHandler;
        
        (function (ShortcutsHandler, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            /**
             * Various functions that register hotkey bindings.
             * @type {Array}
             */
            var shortcutHandlers = [];

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * Refreshes all shortcuts on page, for example after adding content to it via AJAX, or displaying a dialog.
             * @memberOf Lfl.Shortcuts.ShortcutsHandler
             */
            ShortcutsHandler.refreshShortcuts = function() {
                registerHandlers();
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */
            // TODO - add the split parameters - subject (".select2-input"), keyModifiers, key, action
            function ShortcutHandler (registeringFunction) {
                this.registeringFunction = registeringFunction;
            }

            /*
             |-------------------------------------------------------------------------
             | Pre registered methods */

            // TODO: examine this prototype and create the final methods from it
            // Note: does not work since Chrome is a douche and does not react to ctrl or alt + a, but it is a good
            // example
            shortcutHandlers.push(new ShortcutHandler(function() {
                $(document).on("keypress",".select2",function(event){
                    console.log("Key pressed.");
                    
                    // TODO - Registered listener should have two parameters - key modifiers and key - in this case
                    // we would split the method into two registered listeners and pass
                    // function(event) {return event.ctrlKey|| event.metaKey} into both and
                    // "a", function () {*content of 97/a}, "d" ...
                    // If multiple keybinds should be registered for the same action, they will be registered separately
                    // (this is the opposite case - one registering for muliple keybinds with different actions, which
                    // will also be split)
                    if (event.altKey) {
                        console.log("Ctrl pressed");
                        var id =$(this).parents("div[class*='select2-container']").attr("id").replace("s2id_","");
                        var element =$("#"+id);
                        if (event.which == 97){
                            var selected = [];
                            element.find("option").each(function(i,e){
                                selected[selected.length]=$(e).attr("value");
                            });
                            element.select2("val", selected);
                        } else if (event.which == 100){
                            element.select2("val", "");
                        }
                    }
                });
            }));

            /**
             * Returns the numerical value of this key.
             */
            function key(letter) {
                return letter.charCodeAt(0);
            }

            function registerHandlers() {
                _.each(shortcutHandlers, function(/** ShortcutHandler */handler, key) {
                    handler.registeringFunction();
                });
            }

            /*
             |---------------------------------------------------------------------------------
             | In the end we call register handlers to initialize the shortcuts on page load */

            FunctionsCaller.register(function() {
                registerHandlers();
            });

        }(Shortcuts.ShortcutsHandler = Shortcuts.ShortcutsHandler || {}, jQuery));
    }(Lfl.Shortcuts = Lfl.Shortcuts || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));